import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { LockIcon, MailIcon, UserIcon } from 'lucide-react';
const DeveloperLogin = () => {
  const navigate = useNavigate();
  const [isSignup, setIsSignup] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({
    email: '',
    password: '',
    name: '',
    confirmPassword: ''
  });
  const handleUseDemoCredentials = () => {
    setFormData({
      ...formData,
      email: 'demo@developer.com',
      password: 'demo123'
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const newErrors = {
      email: '',
      password: '',
      name: '',
      confirmPassword: ''
    };
    if (isSignup) {
      if (!formData.name) {
        newErrors.name = 'Name is required';
      }
      if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = 'Passwords do not match';
      }
      if (formData.password.length < 8) {
        newErrors.password = 'Password must be at least 8 characters';
      }
      if (!newErrors.name && !newErrors.password && !newErrors.confirmPassword) {
        localStorage.setItem('developerAuth', 'true');
        localStorage.setItem('developerEmail', formData.email);
        localStorage.setItem('developerName', formData.name);
        navigate('/developer/dashboard');
      }
    } else {
      // Demo login validation
      if (formData.email === 'demo@developer.com' && formData.password === 'demo123') {
        localStorage.setItem('developerAuth', 'true');
        localStorage.setItem('developerEmail', formData.email);
        localStorage.setItem('developerName', 'Demo Developer');
        navigate('/developer/dashboard');
      } else {
        if (!formData.email) {
          newErrors.email = 'Email is required';
        }
        if (!formData.password) {
          newErrors.password = 'Password is required';
        }
        if (formData.email && formData.password) {
          newErrors.email = 'Invalid email or password';
        }
      }
    }
    setErrors(newErrors);
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-543">
      <div className="max-w-md w-full" data-id="element-544">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-545">
          <div className="text-center mb-8" data-id="element-546">
            <div className="flex justify-center mb-4" data-id="element-547">
              <div className="w-16 h-16 bg-[#FF3B30] rounded-full flex items-center justify-center" data-id="element-548">
                <UserIcon className="w-8 h-8 text-white" data-id="element-549" />
              </div>
            </div>
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-550">
              {isSignup ? 'Create Developer Account' : 'Developer Login'}
            </h2>
            <p className="mt-2 text-sm text-gray-600" data-id="element-551">
              {isSignup ? 'Sign up to create your developer profile' : 'Sign in to manage your developer profile'}
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-552">
            {isSignup && <Input label="Full Name" type="text" required placeholder="John Doe" value={formData.name} onChange={e => setFormData({
            ...formData,
            name: e.target.value
          })} error={errors.name} data-id="element-553" />}
            <div data-id="element-554">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-555">
                Email Address
                <span className="text-[#FF3B30] ml-1" data-id="element-556">*</span>
              </label>
              <div className="relative" data-id="element-557">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-558">
                  <MailIcon className="h-5 w-5 text-gray-400" data-id="element-559" />
                </div>
                <input id="email" type="email" required className={`block w-full pl-10 pr-3 py-2 border ${errors.email ? 'border-[#FF3B30]' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30] transition-colors`} placeholder="developer@example.com" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} data-id="element-560" />
              </div>
              {errors.email && <p className="mt-1 text-sm text-[#FF3B30]" data-id="element-561">{errors.email}</p>}
            </div>
            <div data-id="element-562">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-563">
                Password
                <span className="text-[#FF3B30] ml-1" data-id="element-564">*</span>
              </label>
              <div className="relative" data-id="element-565">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-566">
                  <LockIcon className="h-5 w-5 text-gray-400" data-id="element-567" />
                </div>
                <input id="password" type="password" required className={`block w-full pl-10 pr-3 py-2 border ${errors.password ? 'border-[#FF3B30]' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30] transition-colors`} placeholder="••••••••" value={formData.password} onChange={e => setFormData({
                ...formData,
                password: e.target.value
              })} data-id="element-568" />
              </div>
              {errors.password && <p className="mt-1 text-sm text-[#FF3B30]" data-id="element-569">{errors.password}</p>}
            </div>
            {isSignup && <div data-id="element-570">
                <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-571">
                  Confirm Password
                  <span className="text-[#FF3B30] ml-1" data-id="element-572">*</span>
                </label>
                <div className="relative" data-id="element-573">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-574">
                    <LockIcon className="h-5 w-5 text-gray-400" data-id="element-575" />
                  </div>
                  <input id="confirmPassword" type="password" required className={`block w-full pl-10 pr-3 py-2 border ${errors.confirmPassword ? 'border-[#FF3B30]' : 'border-gray-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF3B30] focus:border-[#FF3B30] transition-colors`} placeholder="••••••••" value={formData.confirmPassword} onChange={e => setFormData({
                ...formData,
                confirmPassword: e.target.value
              })} data-id="element-576" />
                </div>
                {errors.confirmPassword && <p className="mt-1 text-sm text-[#FF3B30]" data-id="element-577">
                    {errors.confirmPassword}
                  </p>}
              </div>}
            {!isSignup && <Button type="button" variant="outline" fullWidth onClick={handleUseDemoCredentials} data-id="element-578">
                Use Demo Credentials
              </Button>}
            <Button type="submit" variant="primary" fullWidth size="lg" data-id="element-579">
              {isSignup ? 'Create Account' : 'Sign In'}
            </Button>
          </form>
          {!isSignup && <div className="mt-6 text-center" data-id="element-580">
              <p className="text-xs text-gray-500 bg-gray-50 p-3 rounded-md" data-id="element-581">
                Demo credentials: demo@developer.com / demo123
              </p>
            </div>}
          <div className="mt-6 text-center" data-id="element-582">
            <button onClick={() => {
            setIsSignup(!isSignup);
            setErrors({
              email: '',
              password: '',
              name: '',
              confirmPassword: ''
            });
          }} className="text-sm text-[#FF3B30] hover:text-[#E02E23] font-medium transition-colors" data-id="element-583">
              {isSignup ? 'Already have an account? Sign in' : "Don't have an account? Sign up"}
            </button>
          </div>
          <div className="mt-4 text-center" data-id="element-584">
            <Link to="/" className="text-xs text-gray-500 hover:text-gray-700 transition-colors" data-id="element-585">
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default DeveloperLogin;